import React, {Component, Fragment} from 'react';
import ReactGA from 'react-ga';
import PropTypes from 'prop-types';
import Chip from '@material-ui/core/Chip';
import moment from 'moment';
import ListItem from '@material-ui/core/ListItem';
import {I18n} from 'react-redux-i18n';
import Avatar from '@material-ui/core/Avatar';
import Icon from '@material-ui/core/Icon';
import Button from '@material-ui/core/Button';
import CustomDatePicker from '../../components/CustomDatePicker';

const SORT = {
  DESC: 'desc',
  ASC: 'asc'
};

export default class DateTimeFilterDesktop extends Component {
  static defaultProps = {
    sortBy: SORT.DESC
  }

  static propTypes = {
    onChange: PropTypes.func.isRequired,
    startTime: PropTypes.number.isRequired,
    endTime: PropTypes.number.isRequired,
    sortBy: PropTypes.string
  }

  static ranges = {
    'Today': {
      startTime: moment().startOf('day'),
      endTime: moment().endOf('day'),
      label: I18n.t('filter.date.range.today')
    },
    'Yesterday': {
      startTime: moment().subtract(1, 'days').startOf('day'),
      endTime: moment().subtract(1, 'days').endOf('day'),
      label: I18n.t('filter.date.range.yesterday')
    },
    'Last 7 Days': {
      startTime: moment().subtract(6, 'days').startOf('day'),
      endTime: moment().endOf('day'),
      label: I18n.t('filter.date.range.last7days')
    },
    'Last 30 Days': {
      startTime: moment().subtract(29, 'days').startOf('day'),
      endTime: moment().endOf('day'),
      label: I18n.t('filter.date.range.last30days')
    }
  }

  getChipTimeClass(period) {
    const times = DateTimeFilterDesktop.ranges[period];
    if (times) {
      if (times.startTime.valueOf() === this.props.startTime
        && times.endTime.valueOf() === this.props.endTime) {
        return 'chip__selected';
      }
    }

    return 'librarylist__datechips';
  }

  handleChipTime(type) {
    const times = DateTimeFilterDesktop.ranges[type];
    if (times) {
      const startTime = times.startTime.valueOf();
      const endTime = times.endTime.valueOf();
      this.props.onChange({startTime, endTime});
    }
    ReactGA.event({
      category: 'Library Filter',
      action: type,
      label: 'DateFilter Chips'
    });
  }


  handleOnChangedDate(date, convertedToTime) {
    const applyProperOnChange = {
      startTime: () => this.props.onChange({[date]: moment(convertedToTime).startOf('day').valueOf()}),
      endTime: () => this.props.onChange({[date]: moment(convertedToTime).endOf('day').valueOf()})
    };
    applyProperOnChange[date]();

    //TODO: GA
    // ReactGA.event({
    //   category: 'Library Filter',
    //   action: (date === 'startTime') ? 'Custom Start Date' : 'Custom End Date',
    //   label: 'Filter Chips'
    // });
  }

  handleOnClickSort() {
    const sort = (this.props.sortBy === SORT.DESC) ? SORT.ASC : SORT.DESC;
    this.props.onChangeSort(sort);
  }

  render() {
    const {sortBy} = this.props;
    return (
      <div>
        <ListItem className="librarylist__datechipscont">
          <Chip
            avatar={
              <Avatar className="chip">
                <Icon className="chip__icon">event</Icon>
              </Avatar>
            }
            label={I18n.t('filter.date.range.today')}
            id="dateFilterToday"
            className={this.getChipTimeClass('Today')}
            onClick={() => this.handleChipTime('Today')}
          />
          <Chip
            avatar={
              <Avatar className="chip">
                <Icon className="chip__icon">event</Icon>
              </Avatar>
            }
            id="dateFilterYesterday"
            label={I18n.t('filter.date.range.yesterday')}
            className={this.getChipTimeClass('Yesterday')}
            onClick={() => this.handleChipTime('Yesterday')}
          />
          <Chip
            avatar={
              <Avatar className="chip">
                <Icon className="chip__icon">event</Icon>
              </Avatar>
            }
            label={I18n.t('filter.date.range.last7days', {amount: 7})}
            className={this.getChipTimeClass('Last 7 Days')}
            onClick={() => this.handleChipTime('Last 7 Days')}
            id="dateFilterLast7Days"
          />
          <Chip
            avatar={
              <Avatar className="chip">
                <Icon className="chip__icon">event</Icon>
              </Avatar>
            }
            label={I18n.t('filter.date.range.last30days', {amount: 30})}
            className={this.getChipTimeClass('Last 30 Days')}
            onClick={() => this.handleChipTime('Last 30 Days')}
            id="dateFilterLast30Days"
          />
        </ListItem>
        <div className="desktopdatepicker__customdate">
          <ListItem>
            <CustomDatePicker
              label={I18n.t('filter.date.start')}
              mode="start"
              onChange={e => this.handleOnChangedDate('startTime', e)}
              max={moment(this.props.endTime).startOf('day').valueOf()}
              min={moment().startOf('day').subtract(180, 'days').valueOf()}
              value={moment(this.props.startTime).format('YYYY-MM-DD')}
              valueInTs={this.props.startTime}
              id="dateFilterStartTime"
              validateError={true}
            />
          </ListItem>
          <ListItem>
            <CustomDatePicker
              label={I18n.t('filter.date.end')}
              mode="end"
              onChange={e => this.handleOnChangedDate('endTime', e)}
              value={moment(this.props.endTime).format('YYYY-MM-DD')}
              valueInTs={this.props.endTime}
              max={moment().endOf('day').valueOf()}
              min={moment(this.props.startTime).endOf('day').valueOf()}
              id="dateFilterEndTime"
              validateError={true}
            />
          </ListItem>
          <Button id="dateFilterSort" className="btn-terciery desktopdatepicker__customdate-btn" onClick={e => this.handleOnClickSort(e)}>
            {sortBy === SORT.DESC && (
              <Fragment><Icon className="desktopdatepicker__customdate-icon">arrow_downward</Icon>{I18n.t('filter.date.descending')}</Fragment>
            )}
            {sortBy === SORT.ASC && (
              <Fragment><Icon className="desktopdatepicker__customdate-icon">arrow_upward</Icon>{I18n.t('filter.date.ascending')}</Fragment>
            )}
          </Button>
        </div>
      </div>
    );
  }
}
